// extracted by mini-css-extract-plugin
export default {"upsellWrapper":"FT","backgroundimage":"GT","header":"HT","headerwrap":"IT","title":"JT","promomessage":"KT","upsellItem":"LT","upsellImg":"MT","helperText":"NT","upsellHeadline":"OT","price":"PT","upsellGross":"QT","upsellNet":"RT","upsellButton":"ST","nutritionfacts":"TT","nutritionimg":"UT","containerwhy":"VT","nutritionwrappwer":"WT","headlinewhy":"XT","boxwhy":"YT","textwhy":"ZT","backbutton":"aU","drawercontainer":"bU","logoheader":"cU","textwrap":"eU","timer":"fU"};
    if(module.hot) {
      // 1715632479230
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  